export const experienceData = {
  label: "My Experience",

  sections: [
    {
      company: "Cyspan Technologies Pvt. Ltd.",
      role: "Frontend Developer Trainee",
      timeline: "Apr 2025 – Dec 2025",
      skills: [
        "Angular",
        "Tailwind CSS",
        "Figma to Code",
        "ERP Systems",
        "Authentication (OTP)",
        "Component Architecture",
      ],
      values: [
        "**Built responsive, high-performance UI components** using Angular and Tailwind CSS, converting 15+ complex Figma designs.",
        "**Integrated the Droid Designer canvas module and enhanced ERP workflows** by enabling dynamic editing capabilities within the platform.",
        "**Migrated the entire codebase to an OTP-based authentication and session management system**, ensuring backward compatibility without breaking existing functionality.",
        "**Improved frontend architecture and maintainability** by owning shared components, refactoring legacy code, adding documentation, and optimizing performance.",
        "**Collaborated cross-functionally with backend and WordPress teams** to ensure seamless API integrations, consistent UI behavior, and efficient end-to-end feature delivery."
      ],
    },
    {
      company: "Pumex Infotech",
      role: "Frontend Developer Intern",
      timeline: "Feb 2025 – Mar 2025",
      skills: [
        "React",
        "Material UI",
        "Recharts",
        "Role-Based Access",
        "Dashboard Development",
      ],
      values: [
        "**Developed a real-time system monitoring dashboard** using React and Material UI with secure, role-based session handling.",
        "**Designed and integrated Recharts-based visual analytics** to improve visibility into system performance metrics.",
      ],
    },
    {
      company: "Simelabs",
      role: "Full-Stack Development Intern",
      timeline: "Oct 2023 – Nov 2023",
      skills: [
        "React",
        "Node.js",
        "Express.js",
        "PostgreSQL",
        "REST APIs",
        "Material UI",
      ],
      values: [
        "**Built a full-stack employee tracking platform** using React, Node.js, Express.js, PostgreSQL, and Material UI.",
        "**Developed RESTful APIs and database schemas**, optimizing data-fetching pipelines for performance and scalability.",
      ],
    },
    {
      company: "IET, VIT Vellore",
      role: "Web Development Lead & Co-Secretary",
      timeline: "Mar 2023 – Aug 2024",
      skills: [
        "Web Development",
        "Leadership",
        "Event Management",
        "Mentorship",
        "UI/UX Design",
      ],
      values: [
        "**Mentored 500+ students through technical sessions and workshops**, fostering hands-on learning and collaboration.",
        "**Coordinated and executed 20+ technical and non-technical events** with cross-functional teams.",
        "**Led the design and development of multiple event websites**, focusing on usability, performance, and visual aesthetics.",
      ],
    },
  ],
};
